<template>
<div class="modal fade" id="modalObsFunil" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Informação.</h4>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label>Deseja adicionar algum comentário ou anotação sobre a atividade realizada? <span>{{ infoTag }}</span></label>
          <textarea v-model="txtInfo" class="form-control" name="txtInfo"> </textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button v-on:click="sendText()" class="third send-btn-modal">
          <span>Enviar</span>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "modalObsFunil",
  props: ['dataModal'],
  data() {
    return {
      infoTag: "(para realizar quebra de linha digite a tag <br>)",
      emitValue: {
        value: '0',
        random: ''
      },
      txtInfo: '',
    }
  },
  watch: {
    emitValue: function (val) {
      this.$emit('update:actionTxtInfo', val)
    }
  },
  methods: {
    closeModal() {
      $('#modalObsFunil').modal('toggle');
    },
    sendText() {
      this.emitValue = {
        value: this.txtInfo,
        random: Math.floor(Math.random() * 500)
      };
      this.txtInfo = '';

      $('#modalObsFunil').modal('toggle');
    }
  }
}
</script>

<style lang="scss">
#modalObsFunil {
  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  label {
    span {
      font-size: 12px;
      display: inline-block;
      margin-left: 5px;
    }
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00a651;
      color: #fff;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008d45;
      }
    }

    .second {
      background: #0F77AE;
      color: #fff;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #c29d0b;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #aa890a;
      }
    }

    .four {
      background: #e74a4e;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #e43338;
      }
    }
  }

  .form-group {
    display: inline-block;
    margin-bottom: 20px;

    input {
      height: 37px;
    }

    textarea {
      border-radius: 4px !important;
      height: 150px;
      margin-top: 10px;
    }
  }

  .send-btn-modal {
    background: #3598dc;
    color: #fff;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalObsFunil.vue